module.exports = __webpack_public_path__ + "img/moto.f161a17e.svg";